import React, { useState } from "react";
import axios from "axios";
import { config } from "../../../../config";
import ReactQuill from "react-quill"; // ReactQuill ইম্পোর্ট
import "react-quill/dist/quill.snow.css"; // Quill এর স্টাইল ইম্পোর্ট
import imageCompression from "browser-image-compression";

const apiUrl = config.apiUrl;

const CreateHome = ({ onHomeCreated }) => {
  const [formData, setFormData] = useState({
    topBar: "",
    headline: "",
    subHeadline: "",
    paragraph: "",
    timeText: "",
    startsText: "",
    startsIn: "",
    seatGrabText: "",
    buttonHeadlineText: "",
    buttonSubheadlineText: "",
    secretsHeadline: "",
    secretsText: "",
    footerText: "",
    image: null,
    pixelId: "",
  });

  const [error, setError] = useState(null);

  const imageCompressionOptions = {
    maxSizeMB: 0.5, 
    maxWidthOrHeight: 1024, 
    useWebWorker: true,
    fileType: "image/webp"
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const compressedBlob = await imageCompression(file, imageCompressionOptions);
      
      const fileName = file.name.replace(/\.[^/.]+$/, "") + ".webp";
      const compressedFile = new File([compressedBlob], fileName, {
        type: "image/webp",
        lastModified: Date.now()
      });

      setFormData(prev => ({ 
        ...prev, 
        image: compressedFile 
      }));
    } catch (error) {
      console.error("Image compression error:", error);
      setError("Failed to compress image");
    }
  };


  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleQuillChange = (value) => {
    setFormData((prev) => ({ ...prev, secretsText: value || "" })); // Always set a string value
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      data.append(key, formData[key]);
    });

    try {
      await axios.post(`${apiUrl}/homepages`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Homepage Section Created Successfully!");
      onHomeCreated();
    } catch (err) {
      console.log(err?.response?.data?.message) 
      setError("An error occurred while creating the homepage.");
    }
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Homepage Section</h2>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700">Top Bar</label>
          <input
            type="text"
            name="topBar"
            value={formData.topBar}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Headline</label>
          <input
            type="text"
            name="headline"
            value={formData.headline}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>
       
        <div className="mb-4">
          <label className="block text-gray-700">Sub Headline</label>
          <input
            type="text"
            name="subHeadline"
            value={formData.subHeadline}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Paragraph</label>
          <textarea
            name="paragraph"
            value={formData.paragraph}
            onChange={handleChange}
            className="border w-full p-2"
          ></textarea>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Image</label>
          <input
            type="file"
            name="image"
            onChange={handleImageChange}
            className="border w-full p-2"
            accept="image/*"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Time Text</label>
          <input
            type="text"
            name="timeText"
            value={formData.timeText}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Next Masterclass, Next Webinar, etc."
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Starts Text</label>
          <input
            type="text"
            name="startsText"
            value={formData.startsText}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., Starts in"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Starts In</label>
          <input
            type="text"
            name="startsIn"
            value={formData.startsIn}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., 10 minutes"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Seat Grab Text</label>
          <input
            type="text"
            name="seatGrabText"
            value={formData.seatGrabText}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Button Headline Text</label>
          <input
            type="text"
            name="buttonHeadlineText"
            value={formData.buttonHeadlineText}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Button Subheadline Text</label>
          <input
            type="text"
            name="buttonSubheadlineText"
            value={formData.buttonSubheadlineText}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        {/* <div className="mb-4">
          <label className="block text-gray-700">Secrets Headline</label>
          <input
            type="text"
            name="secretsHeadline"
            value={formData.secretsHeadline}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Secrets Text</label>
          <ReactQuill
            value={formData.secretsText || ""} // Ensure Quill gets a valid string
            onChange={handleQuillChange}
            className="border w-full p-2"
          />
        </div> */}
        
        {/* <div className="mb-4">
          <label className="block text-gray-700">Footer Text</label>
          <input
            type="text"
            name="footerText"
            value={formData.footerText}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div> */}
     

        {/* <div className="mb-4">
          <label className="block text-gray-700">Facebook Pixel Id</label>
          <input
            name="pixelId"
            value={formData.pixelId}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div> */}

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Create Homepage
        </button>
      </form>
    </div>
  );
};

export default CreateHome;
